import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import LiquidationsList from './slideshow';
import LiquidationsDetail from './detail';

export const liquidationsRoutes = [
  {'component': <LiquidationsList />, 'path': paths.LiquidationsList},
  {'component': <LiquidationsDetail />, 'path': paths.LiquidationsDetail},
];
